var jwt_decode = require('jwt-decode');


export function getuser() {
    let userTk = localStorage.getItem('hondixTk');
    var decoded = jwt_decode(userTk);
    return decoded;
}

export function isCustomerUser() {
    return getuser().type === "C" ? true : false;
}

export function isAdministratorUser() {
    return getuser().type === "A" ? true : false;
}

export function isRepresentativeUser() {
    return getuser().type === "R" ? true : false;
}

export function getName() {
    let userTk = localStorage.getItem('hondixTk');
    var decoded = jwt_decode(userTk);
    let name = decoded.Name.split(' ');
    return name[0] + ' ' + name[1];
}

export function getStatus() {
    let userTk = localStorage.getItem('hondixTk');
    var decoded = jwt_decode(userTk);
    let status = decoded.Status
    return status;
}